<template>
  <hero-75>
    <h1>What sharks do for us</h1>
  </hero-75>
</template>

<script>
import Hero75 from "@/components/Hero75.vue";

export default {
  name: "1WhySharksAreImportant",
  components: {
    Hero75
  }
}
</script>

<style scoped lang="scss">
h1 {
  font-size: 6em;
  font-family: "acumin-pro-condensed";
  text-align: center;
  text-transform: uppercase;
}
</style>